import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import * as queryString from 'query-string';
import * as React from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';

import { SignUpModeEnum } from '@app/app.enum';
import { history } from '@app/app.routes';
import * as defaultLogo from '@app/assets/images/default-logo.png';
import * as maerskLogo from '@app/assets/images/maersk-logo-rgb.svg';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import * as models from '@app/models';
import { IAxiosCancellation } from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { SharedService } from '@app/services/shared.service';
import Axios from 'axios';
import _ from 'lodash';

export interface IInvitationState {
	logo: string;
	companyName: string;
	firstName: string;
	appName: string;
	appCompanyName: string;
	partnerAppId: string;
	parentAccountId: string;
	error: models.IErrorResponse;
	isPartnerInvite: boolean;
	signUpKey: string;
	signUpMode: SignUpModeEnum;
}

export interface IInvitationProps extends IAxiosCancellation {
	location: models.ILocationProps;
	intl: InjectedIntl;
}

const accountService: AccountService = Injector.get(AccountService);
const sharedServive: SharedService = Injector.get(SharedService);

class InvitationComponent extends React.Component<IInvitationProps, IInvitationState> {
	constructor(props: IInvitationProps) {
		super(props);
		this.state = {
			logo: defaultLogo,
			appCompanyName: '',
			appName: '',
			companyName: '',
			firstName: '',
			partnerAppId: '',
			parentAccountId: '',
			error: null,
			isPartnerInvite: false,
			signUpKey: '',
			signUpMode: null,
		};
	}

	public componentDidMount() {
		if (this.props.location.search) {
			this.getQueryParams();
		}
	}

	public render() {
		let message = (
			<Grid container={true} spacing={2}>
				<Grid item={true} xs={12}>
					<div>
						{this.props.intl.formatMessage({
							id: 'app.invitation.invitation-dear-customer',
						})}
					</div>
				</Grid>
				<Grid item={true} xs={12}>
					<div>
						{this.props.intl.formatMessage({
							id: 'app.invitation.invitation-description-by',
						})}
						{this.state.companyName}
						{this.state.isPartnerInvite ? this.getTemplatePartnerAccount() : this.getTemplateNonPartnerAccount()}
					</div>
				</Grid>
				<Grid item={true} xl={12} lg={12} md={12} sm={12}>
					<Grid container={true} alignItems='flex-end' direction='row'>
						<Grid item={true} xl={8} lg={8} md={8} sm={12}>
							<div>
								{this.props.intl.formatMessage({
									id: 'app.invitation.invitation-thanks-and-regard',
								})}
							</div>
							<div>{this.state.firstName}</div>
							<div>{this.state.companyName}</div>
						</Grid>
						<Grid item={true} xl={4} lg={4} md={4} sm={12}>
							<img src={this.state.logo} width='75' height='75' />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		);

		if (this.state.error) {
			message = (
				<Grid container={true} spacing={2}>
					<Grid item={true}>
						<Typography color='error' variant='subtitle2'>
							{sharedServive.parseError(this.state.error)}
						</Typography>
					</Grid>
				</Grid>
			);
		}

		return (
			<main className='sign-up-root'>
				<div className='text-center pb-2'>
					<div className='genesis-text'>
						<img src={maerskLogo} className='genesis-logo-signin-signup' />
					</div>
				</div>
				<Card>
					<CardContent className='pt-5 invitation-text'>
						{message}
						<div className='pt-3 text-center'>
							<Button type='button' variant='outlined' color='inherit' fullWidth={true} onClick={this.navigateToSignUp}>
								{this.props.intl.formatMessage({
									id: 'app.signup.signup-button-text',
								})}
							</Button>
						</div>
					</CardContent>
				</Card>
				{!this.state.signUpMode && (
					<div className='text-center pt-2 outer-card-area'>
						<div>Already Registered?</div>
						<div className='pt-1'>
							<Button type='button' variant='outlined' color='inherit' onClick={this.navigateToSignIn}>
								{this.props.intl.formatMessage({
									id: 'app.signup.signin-suggest-button-text',
								})}
							</Button>
						</div>
					</div>
				)}
			</main>
		);
	}

	private navigateToSignUp = () => {
		const url = this.state.signUpMode ? '/signup/quick' : '/signup';

		if (this.state.error) {
			history.push(url);
			return;
		}
		let param: string;
		if (this.state.isPartnerInvite) {
			param = queryString.stringify({
				SignupKey: this.state.signUpKey,
			});
		} else {
			param = queryString.stringify({
				partnerAppId: this.state.partnerAppId,
				parentAccountId: this.state.parentAccountId,
			});
		}
		history.push(`${url}?` + param);
		return;
	};

	private navigateToSignIn = () => {
		if (this.state.error) {
			history.push('/signin');
			return;
		}
		let param: string;
		if (this.state.isPartnerInvite) {
			param = queryString.stringify({
				SignupKey: this.state.signUpKey,
			});
		} else {
			param = queryString.stringify({
				partnerAppId: this.state.partnerAppId,
				parentAccountId: this.state.parentAccountId,
			});
		}
		history.push('/signin?' + param);
		return;
	};

	private async getQueryParams() {
		try {
			// Making all the keys of query-string parsed object to lowercase so to ignore casing in matching query params
			const queryParams = _.mapKeys(queryString.parse(this.props.location.search), (value, key) => key.toLowerCase());
			this.setState({
				signUpMode: queryParams.mode as SignUpModeEnum,
			});
			if (
				queryParams.partnerappid &&
				queryParams.partnerappid.toString() &&
				queryParams.parentaccountid &&
				queryParams.parentaccountid.toString()
			) {
				const res = await accountService.GetInvitationData(
					queryParams.partnerappid.toString(),
					queryParams.parentaccountid.toString(),
					this.props.axiosCancellationToken
				);

				this.setState({
					companyName: res.parentCompanyName,
					logo: res.parentCompanyLogo ? res.parentCompanyLogo : defaultLogo,
					appName: res.appName,
					firstName: res.parentUserName,
					appCompanyName: res.partnerCompanyName,
					partnerAppId: queryParams.partnerappid.toString(),
					parentAccountId: queryParams.parentaccountid.toString(),
				});
			} else if (queryParams.signupkey && queryParams.signupkey.toString()) {
				const res = await accountService.GetPartnerInvitationData(queryParams.signupkey.toString());
				this.setState((prevState: IInvitationState) => ({
					...prevState,
					companyName: res.parentCompanyName,
					logo: res.parentCompanyLogo ? res.parentCompanyLogo : defaultLogo,
					isPartnerInvite: true,
					signUpKey: queryParams.signupkey.toString(),
				}));
			} else {
				this.navigateToSignIn();
			}
		} catch (err) {
			if (!Axios.isCancel(err)) {
				this.setState({
					error: err.data,
				});
			}
		}
	}

	private getTemplatePartnerAccount = () => (
		<>
			{this.props.intl.formatMessage({
				id: 'app.invitation.partner-invitation-description-access',
			})}
		</>
	);

	private getTemplateNonPartnerAccount = () => (
		<>
			{this.props.intl.formatMessage({
				id: 'app.invitation.invitation-description-access',
			})}
			<span className='bold'>{this.state.appName}</span>
			<span>
				{this.props.intl.formatMessage({
					id: 'app.invitation.invitation-description-published-by',
				})}
			</span>
			{this.state.appCompanyName}
		</>
	);
}

export default withAxiosCancellation(injectIntl(InvitationComponent));



// WEBPACK FOOTER //
// ./src/components/account/invitation/invitation.component.tsx